angular
  .module("AccountingBoxApp")
  .controller("ContactsMasterDetailCtrl", function(
    $scope,
    $location,
    $filter,
    $transition$,
    $state,
    Customer,
    customers
  ) {
    var vm = this;

    vm.customers = customers;

    vm.navigateToFirst = function() {
      if (vm.customers.length > 0) {
        var customerId = vm.customers[0].id;
        $state.go("app.company.contacts.edit", { id: customerId });
      }
    };

    if ($state.current.name === "app.company.contacts") {
      vm.navigateToFirst();
    }

    vm.isActive = function(contact) {
      return $transition$.params().id === contact.id;
    };

    vm.reload = function() {
      return Customer.find({
        filter: { order: "name ASC" }
      }).$promise.then(function(customers) {
        vm.customers = customers;
      });
    };

    vm.handleSave = function(customer) {
      customer
        .$save()
        .then(vm.reload)
        .then(function() {
          $state.go("app.company.contacts.edit", { id: customer.id });
        }).then(function() {
          $("body")
            .pgNotification({
              message: "Klant opgeslagen",
              type: "success",
              style: "flip"
            })
            .show();
        }
      ).catch(function(response) {
        window.swal(
          "Opslaan mislukt",
          response.data.error.message,
          "error"
        );
      });

    };

    vm.handleDelete = function(customer) {
      Customer.deleteById({
        id: customer.id
      })
        .$promise.then(function() {
          vm.reload().then(function() {
            setTimeout(vm.navigateToFirst, 500); //delay for modal backdrop issue
          });
        })
        .catch(function(response) {
          window.swal(
            "Verwijderen mislukt",
            response.data.error.message,
            "error"
          );
        });
    };
  });
